import { BaseStore } from '../base/base.store';
import { IBaseState } from '../base/base.state';

export class DynamicContentSchemaStore extends BaseStore {

  constructor(baseState: IBaseState, schemaName: string) {
    super(baseState, schemaName);
  }
}
